var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMagicPen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.09733 14.9028C3.67372 15.4792 4.60428 15.4792 5.18066 14.9028L14.2084 5.875C14.7848 5.29861 14.7848 4.36806 14.2084 3.79167C13.6321 3.21528 12.7015 3.21528 12.1251 3.79167L3.09733 12.8194C2.52094 13.3958 2.52094 14.3264 3.09733 14.9028Z",
    stroke: "#505152",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1737 6.90951L11.0903 4.82617",
    stroke: "#505152",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5695 2.36073L7.61117 2.05518L7.30561 3.09684L7.61117 4.13851L6.5695 3.83295L5.52783 4.13851L5.83339 3.09684L5.52783 2.05518L6.5695 2.36073Z",
    stroke: "#505152",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79167 6.52772L4.83333 6.22217L4.52778 7.26383L4.83333 8.3055L3.79167 7.99995L2.75 8.3055L3.05556 7.26383L2.75 6.22217L3.79167 6.52772Z",
    stroke: "#505152",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2084 9.99989L15.2501 9.69434L14.9445 10.736L15.2501 11.7777L14.2084 11.4721L13.1667 11.7777L13.4723 10.736L13.1667 9.69434L14.2084 9.99989Z",
    stroke: "#505152",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicPen);
export default __webpack_public_path__ + "static/media/magic-pen.12f4b4439957944ddd38fb4c688d546f.svg";
export { ForwardRef as ReactComponent };